import classnames from "classnames";
import { FunctionComponent, memo } from "react";

import "./table-menu-item.scss";
import { IProps } from "./table-menu-item.types";

/**
 * Show an item in a table menu list.
 * @param props.children    Item content.
 * @param props.isActive    If the item has been activated.
 * @param props.className   Any class names passed when component is called.
 * @returns              Menu item.
 */
const TableMenuItem: FunctionComponent<IProps> = ({ children, isActive, className, isDisabled, ...otherProps }) => {
    return (
        <button
            type="button"
            className={classnames(className, "grid__menu-item", {
                "grid__menu-item--is-active": isActive,
                "grid__menu-item--disabled": isDisabled,
            })}
            disabled={isDisabled}
            {...otherProps}
        >
            {children}
        </button>
    );
};

export default memo(TableMenuItem);
